import { Dropdown, type MenuProps } from 'antd';
import type { ReactElement, ReactNode } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../Core/Icon';

interface Props {
  enabled: boolean;
  onCreateFolder: () => void;
  children: ReactElement | ReactNode;
}

/** Right-click “New folder” only — not full FilesContextMenu. */
export function FolderPickerCreateContextMenu({ enabled, onCreateFolder, children }: Props) {
  const { t } = useTranslation();

  const items: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'new-folder',
        label: t('common.createFolder'),
        icon: <Icon name="FolderIcon" className="text-yellow-dark h-5 w-5" />,
        onClick: () => onCreateFolder(),
      },
    ],
    [onCreateFolder, t],
  );

  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <Dropdown menu={{ items }} trigger={['contextMenu']}>
      <div className="h-full min-h-0">{children}</div>
    </Dropdown>
  );
}

export default FolderPickerCreateContextMenu;
